import { getProductSheetLocale } from '@repo/common/helpers';

export const transformDayToDayName = (dayNumber: number, locale?: string) => {
  const date = new Date(); // given: a Date object and an integer representing the week day
  const currentDay = date.getDay();
  const distance = dayNumber - currentDay;
  date.setDate(date.getDate() + distance);

  const intl = new Intl.DateTimeFormat(locale ?? 'en-GB', {
    weekday: 'long',
  });

  return intl.format(date);
};

export const formatAppointmentDate = (
  date: Date,
  locale: string,
  timezone?: string,
): string => {
  const convertedLocale = getProductSheetLocale(locale);

  const day = new Intl.DateTimeFormat(convertedLocale, {
    month: 'long',
    day: 'numeric',
    weekday: 'long',
    timeZone: timezone,
  }).format(date);

  const hour = new Intl.DateTimeFormat(convertedLocale, {
    timeStyle: 'short',
    timeZone: timezone,
  }).format(date);

  return `${day} - ${hour}`;
};
